import Delete from './Delete';

import './Delete.scss';

export default Delete;
